import _ from 'underscore';

export default class ResponsiveMap {
  constructor(img, map) {
    this.img = img;
    // this.mapRes = document.querySelector('map[name='+ img.useMap.replace('#', '') +']');
    this.mapRes = map;
    this.mapOri = this.mapRes.cloneNode(true);

    this.handleResize();
    this.listen();
  }

  handleResize() {
    let self = this;

    for(var i=0; i<this.mapRes.areas.length; i++) {
      this.mapRes.areas[i].coords = self.calcArea(this.mapOri.areas[i].coords)
    }
  }

  listen() {
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  calcArea(coords) {
    var coordsArray = coords.toString().split(',');
    var resizedCoordArray = [];

    for(var i=0; i<coordsArray.length; i++) {
      var resizedCoord;
      if (i % 2 === 0) {
        resizedCoord = (coordsArray[i] * this.img.clientWidth / this.img.naturalWidth).toFixed(2);
      } else {
        resizedCoord = (coordsArray[i] * this.img.clientHeight / this.img.naturalHeight).toFixed(2);
      }

      resizedCoordArray.push(resizedCoord);
    }
    return resizedCoordArray.join(',');
  }

  getMapOri() {
    return this.mapOri;
  }
}
